import React from 'react';
import { useTranslation } from 'react-i18next';
import InsightsCaughtUp from '@static/images/empty-state/insights-caught-up.svg';


import * as S from './NoEvents.styles';


export const NoEvents = () => {
  const { t } = useTranslation(['whatsNew']);

  return (
    <S.Root data-testid="overview-event-feed-no-insights">
      <InsightsCaughtUp />
      <S.DescriptionText>
        <S.TitleText>{t('whatsNew:youAreAllCaughtUp')}</S.TitleText>
        {t('whatsNew:noInsights')}
      </S.DescriptionText>
    </S.Root>
  );
};
